$(document).ready(function () {
    document.addEventListener('hidden.bs.offcanvas', function (event) {
        const anyOpen = document.querySelector('.offcanvas.show, .modal.show');
        if (!anyOpen) {
            document.body.style.setProperty('overflow-y', 'auto', 'important');
        }
    });
    document.addEventListener('show.bs.offcanvas', function (event) {
        document.body.style.overflow = 'hidden';
        $('.mobile-menu-items.children').hide();
    });

    // $('.mobile-menu-item.children-dropdown .mobile-menu-item-link').on('click', function (event) {
    //     $(this).parent('.mobile-menu-item.has-children').toggleClass('open')
    // })

    $('.mobile-menu-item.has-children > .mobile-menu-item-link').on('click', function (event) {
        let $parentItem = $(this).parent('.mobile-menu-item.has-children');
        let $submenu = $parentItem.children('.mobile-menu-items.children');
        $parentItem.find('.mobile-menu-item.has-children.open').removeClass('open').children('.mobile-menu-items.children').slideUp(300);
        if ($parentItem.hasClass('open')) {
            $parentItem.removeClass('open');
            $submenu.slideUp(300);
        } else {
            $parentItem.addClass('open');
            $submenu.slideDown(300);
        }
    });

    $('.toggle-show').on('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        const selector = $(this).attr('data-target');
        $(selector).toggleClass('show');
    });


    // search box
    $(".mega-menu-search-container").width($('#navbar-menu-data').width());
    $(window).on('resize', function () {
        if ($(".mega-menu-search-container").width() != $('#navbar-menu-data').width()) {
            $(".mega-menu-search-container").width($('#navbar-menu-data').width());
        }
    });

    $('#searchBtnAll').on('click', function (e) {
        e.stopPropagation();
        $('#searchMegaMenu').toggle();
        $('#menuSearchInput').focus();
    });
    $(document).on('click', function (e) {
        if (!$(e.target).closest('#searchMegaMenu, #searchBtnAll').length) {
            $('#searchMegaMenu').hide();
        }
    });
    const scrollBtn = $('#scrollToTopBtn');
    $(window).scroll(function () {
        if ($(window).scrollTop() > 300) {
            scrollBtn.fadeIn();
        } else {
            scrollBtn.fadeOut();
        }
    });
    scrollBtn.click(function () {
        $('html, body').animate({scrollTop: 0}, 600);
        return false;
    });

    const menu = $('.navbar-container');
    const menuOffset = menu.offset().top;
    const menuHeight = menu.outerHeight();
    $(window).on('scroll', function () {
        if ($(window).scrollTop() > menuOffset) {
            menu.addClass('menu-fixed');
            $('body').css('padding-top', menuHeight + 'px');
        } else {
            menu.removeClass('menu-fixed');
            $('body').css('padding-top', '0');
        }
    });

    $('.select2').select2({
        width: '100%',
        theme: 'bootstrap',
        language: {
            noResults: function () {
                return "Không có kết quả tìm kiếm";
            }
        },
        matcher: function (params, data) {
            if (jQuery.trim(params.term) === '') {
                return data;
            }
            let text = data.text.toLowerCase();
            let term = params.term.trim().toLowerCase();

            if (text.indexOf(term) > -1) {
                return data;
            }
            return null;
        }
    });

    $(".datepicker").datepicker({
        orientation: 'auto',
        forceParse: true,
        calendarWeeks: true,
        autoclose: true,
        format: "dd/mm/yyyy",
        language: 'vi',
        container: 'body',
        startDate: "01/01/1900",
        endDate: "31/12/2099"
    });

    $(".year-picker").datepicker({
        orientation: 'auto',
        format: "yyyy",
        viewMode: "years",
        minViewMode: "years",
        daysOfWeekDisabled: "0",
        forceParse: true,
        calendarWeeks: true,
        autoclose: true,
        language: 'vi',
        container: 'body',
        startDate: "1900",
        endDate: "2099",
    });

    $(".featured-video-play").on('click', function () {
        const mediaContent = $(this).data('media-content');
        const videoTitle = $(this).data('title');
        if (mediaContent) {
            $.fancybox.open({
                src: mediaContent,
                type: 'html',
                smallBtn: false,
                touch: true,
                toolbar: true,
                buttons: [
                    'zoom',
                    'fullscreen',
                    'close',
                    'share',
                ],
                caption: videoTitle,
                animationEffect: "fade",
                transitionEffect: "fade",
                transitionDuration: 300,
                speedIn: 200,
                speedOut: 200,
                closeClick: true,
                afterShow: function (instance, current) {
                },
                beforeClose: function (instance, current) {
                },
                protect: true,
                loop: false,
                autoFocus: false,
            });
        }
    });
    $(".video-title").on('click', function (event) {
        event.stopPropagation();
    });
    if (typeof FB !== "undefined") {
        FB.init({
            appId: $(".fbShare").data("id"),
            xfbml: true,
        });
    } else {
        console.error("Facebook SDK chưa được tải!");
    }

    $(document).on("click", ".fbShare", function () {
        if (typeof FB === "undefined") {
            console.error("Facebook SDK chưa được tải!");
            return;
        }

        const $this = $(this);
        // FB.ui({
        //     method: "feed",
        //     link: $this.data("url"),
        //     picture: $this.data("image"),
        //     name: "",
        //     caption: "",
        //     description: "",
        //     message: ""
        // });
        const url = encodeURIComponent($('meta[property="og:url"]').attr("content"));
        const fbShareUrl = "https://www.facebook.com/sharer/sharer.php?u=" + url;
        window.open(fbShareUrl, "Share on Facebook", "width=600,height=400");
    });

    $(".toggle-password").click(function () {
        let target = $(this).data("target");
        let input = $(target);
        let icon = $(this).find("i");

        if (input.attr("type") === "password") {
            input.attr("type", "text");
            icon.removeClass("fa-eye").addClass("fa-eye-slash");
        } else {
            input.attr("type", "password");
            icon.removeClass("fa-eye-slash").addClass("fa-eye");
        }
    });

    $.extend($.easing, {
        easeOutCubic: function(x, t, b, c, d) {
            return c * ((t = t / d - 1) * t * t + 1) + b;
        },
        easeOutQuint: function(x, t, b, c, d) {
            return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
        }
    });
    const tabMenuContainer = $('.tab-menu-container');
    tabMenuContainer.on('wheel', function (event) {
        event.preventDefault();
        const delta = event.originalEvent.deltaY || event.originalEvent.deltaX;
        $(this).scrollLeft($(this).scrollLeft() + delta);
    });

    function centerActiveTab(container) {
        const activeItem = container.find('.tab-link-menu-item.active, .tab-menu-item.active');
        if (activeItem.length) {
            const containerWidth = container.width();
            const itemOffset = activeItem.position().left;
            const itemWidth = activeItem.outerWidth();
            const scrollTo = itemOffset - (containerWidth / 2) + (itemWidth / 2);
            container.stop().animate({
                scrollLeft: scrollTo
            }, {
                duration: 300,
                easing: 'easeOutCubic',
                complete: function () {
                    checkScrollButtons(container);
                }
            });
        }
    }

    function checkScrollButtons(container) {
        if ($(window).width() <= 767) {
            container.closest('.tab-menu-wrapper').find('.tab-scroll-btn').hide();
            return;
        }

        const scrollWidth = container[0].scrollWidth;
        const clientWidth = container[0].clientWidth;
        const hasScroll = scrollWidth > clientWidth;

        const containerWrapper = container.closest('.tab-menu-wrapper');
        const scrollLeftBtn = containerWrapper.find('.tab-scroll-btn.left');
        const scrollRightBtn = containerWrapper.find('.tab-scroll-btn.right');

        const scrollPosition = container.scrollLeft();
        const canScrollLeft = scrollPosition > 0;
        const canScrollRight = scrollPosition < scrollWidth - clientWidth - 1;

        if (!hasScroll) {
            scrollLeftBtn.hide();
            scrollRightBtn.hide();
            return;
        }
        // scrollLeftBtn.toggle(canScrollLeft);
        // scrollRightBtn.toggle(canScrollRight);
        scrollLeftBtn.show().toggleClass('disabled', !canScrollLeft);
        scrollRightBtn.show().toggleClass('disabled', !canScrollRight);
    }

    $('.tab-scroll-btn').on('click', function () {
        if ($(this).hasClass('disabled')) return;
        const container = $(this).closest('.tab-menu-wrapper').find('.tab-menu-container');
        const scrollAmount = container.width() * 0.4;

        let newScrollLeft;
        if ($(this).hasClass('left')) {
            newScrollLeft = Math.max(0, container.scrollLeft() - scrollAmount);
        } else {
            newScrollLeft = Math.min(
                container[0].scrollWidth - container[0].clientWidth,
                container.scrollLeft() + scrollAmount
            );
        }

        container.stop().animate({
            scrollLeft: newScrollLeft
        }, {
            duration: 300,
            easing: 'easeOutQuint',
            complete: function () {
                checkScrollButtons(container);
            }
        });
    });

    tabMenuContainer.on('scroll', function () {
        checkScrollButtons($(this));
    });

    tabMenuContainer.each(function () {
        const container = $(this);
        centerActiveTab(container);
        checkScrollButtons(container);
    });

    let resizeTimer;
    $(window).on('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            tabMenuContainer.each(function () {
                const container = $(this);
                centerActiveTab(container);
                checkScrollButtons(container);
            });
        }, 250);
    });

    // menu
    $('li.has-dropdown').on('mouseenter', function () {
        const $submenu = $(this).children('.dropdown .has-dropdown > .dropdown');

        // Hiển thị tạm để đo
        $submenu.css('display', 'block').removeClass('upward');

        const offset = $submenu.offset();
        const height = $submenu.outerHeight();
        const windowBottom = $(window).scrollTop() + $(window).height();

        if (offset?.top + height > windowBottom) {
            $submenu.addClass('upward');
        }

        $submenu.css('display', '');
    });

    $('li.has-dropdown').on('mouseleave', function () {
        const $submenu = $(this).children('ul.dropdown');
        $submenu.removeClass('upward');
    });
});

function openInWebsite(selectElement) {
    const url = selectElement.value;
    if (url && url !== '#') {
        window.open(url, '_blank');
    }
}

$(document).on('click', '.tab-data', function (e) {
    e.preventDefault();

    const key = $(this).data('key');
    const value = $(this).data('value');
    const url = new URL(window.location.href);
    const params = url.searchParams;

    params.set(key, value);
    params.set('page', '1');

    window.location.href = url.pathname + '?' + params.toString();
});

